import { osPlatform } from "../../store/GlobalVarriables";

import "./style.scss";

export const BottomFixedContainer = ({ children }) => {
  return (
    <div
      className="bottom-fixed-container"
      style={{
        bottom: osPlatform === "iOS" ? "88px" : "72px",
      }}
    >
      {children}
    </div>
  );
};
